const MIGRATION = {
  USER_TYPE_MISSING: 'User type is missing',
  INVALID_USER_TYPE: 'Invalid user type',
  NO_EMAIL: 'No Email',
  ALREADY_IN_PROGRESS:
    'User role migration is already in progress. Please wait for the current migration to complete before initiating a new one.',
};

export default MIGRATION;
